import i18n from "../i18n";
import React, { useState, useEffect } from "react";
import {
  Text,
  TextInput,
  Kbd,
  Button,
  Flex,
  UnstyledButton,
} from "@mantine/core";
import {
  IconArrowBackUp,
  IconArrowUp,
  IconArrowUpBar,
  IconSearch,
  IconSectionSign,
  IconSeparatorVertical,
  IconSlash,
} from "@tabler/icons";
import { useTabNavigate } from "../hooks/useTabNavigate";
import { openSpotlight } from "@mantine/spotlight";
import { useTranslation } from "react-i18next";

const RightSection = () => <Kbd mr={5}>{i18n.t("Ctrl")}</Kbd>;

const SearchBox = ({}) => {
  const [searchText, setSearchText] = useState("");
  const tabNav = useTabNavigate();
  const { t } = useTranslation();

  const search = (text) => {
    // console.log("search", searchText);
    tabNav.open({
      pathname: "/search",
      search: `?q=${searchText}`,
      label: "Search",
    });
    setSearchText("");
  };

  const handleKeyDown = (e) => {
    // console.log("keydown", e.code);
    if (e.code === "Enter" || e.code === "NumpadEnter") {
      return search(e.target.value);
    }
  };

  const openSpotLight = () => {
    openSpotlight();
  };

  return (
    <>
      {/* Search Text :{searchText} */}

      <TextInput
        width={100}
        size="xs"
        mx={"md"}
        mb={"sm"}
        placeholder={t("Search Text + Enter")}
        icon={<IconSearch size="0.8rem" />}
        onChange={(e) => setSearchText(e.currentTarget.value)}
        onKeyDown={(e) => handleKeyDown(e)}
        value={searchText}
        rightSection={
          <UnstyledButton onClick={() => openSpotLight()}>
            <IconSeparatorVertical size="0.8rem" />
          </UnstyledButton>
        }
      />
    </>
  );
};

export default SearchBox;
